// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StepperContext } from "@flip/App/Widgets/CheckoutStepper/StepperContext";
import { mergeWithCss } from "@flip/XDL/Utilities";
import { iconLinkCommonStyles } from "@flip/XDL/Utilities/links";
import translate from "@insite/client-framework/Translate";
import Edit from "@insite/mobius/Icons/Edit";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import React, { useContext, useState } from "react";

interface CheckoutMoveToStepProps {
    label?: string;
    moveToStep?: number;
    extendedStyles?: CheckoutMoveToStepStyles;
}

export interface CheckoutMoveToStepStyles {
    editLink?: LinkPresentationProps;
}

export const checkoutMoveToStepStyles: CheckoutMoveToStepStyles = {
    editLink: {
        ...iconLinkCommonStyles(Edit),
    },
};

const CheckoutMoveToStep = ({ label, moveToStep, extendedStyles }: CheckoutMoveToStepProps) => {
    const [styles] = useState(() => mergeWithCss(checkoutMoveToStepStyles, extendedStyles));
    const { moveToStepHandler } = useContext(StepperContext);
    const moveTo = () => {
        if (typeof moveToStep !== "number") {
            return;
        }

        moveToStepHandler(moveToStep);
    };

    if (typeof moveToStep !== "number") {
        return null;
    }

    return (
        <Link {...styles.editLink} aria-label={`move-to-${label}`} onClick={moveTo}>
            {translate(`Edit ${label || ""}`)}
        </Link>
    );
};

export default CheckoutMoveToStep;
